<template>
  <div class="home">
    <div id="nav">
      <Header></Header>
      <Nav></Nav>
    </div>
    <router-view/>
    <!-- 底部 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import Header from '@/views/frontDesk/components/Header'
import Nav from '@/views/frontDesk/components/Nav.vue'
import Bottom from "@/views/frontDesk/components/Bottom.vue";
export default {
  name:"home",
  components: {
    Bottom,
		Header,
		Nav
  },
  
    data() {
    return {
    };
  },
  mounted() {
  },
 
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.home{
	height: 100%;
}
</style>